import React from "react";
import { Calendar } from "primereact/calendar";
import styled from "styled-components";
import { PrimaryButton } from "./Button";

export interface DatepickerProps {
  locale: any;
  mode: string;
  placeholder: string;
  value: any;
  checkbox?: any;
  labelButton: string;
  minDate?: any;
  maxDate?: any;
  onSelectDate: (dates: Array<any>) => void;
  onSearchDate: () => void;
}

const PickerContainer = styled.div`
  margin-top: 1rem;
  margin-bottom: 2rem;
  display: flex;
  @media (max-width: 768px) {
     flex-direction:column;
  }
`;

const CheckContainer = styled.div`
  margin-right: 1rem;
  padding-top: 1rem;
  @media (max-width: 768px) {
      margin:0.5rem 0 1.5rem 0;
      padding:0
  } 
`;

const MyCalendar = styled(Calendar)`
  .p-inputtext:enabled:focus {
    box-shadow: unset !important;
    -webkit-box-shadow: unset !important;
    border-color: #dd052b !important;
  }
  .p-inputtext {
    border: solid 1px #dd052b !important;
    width:15rem!important;
    margin-right:1rem;
     @media (max-width: 768px) {
      width:90vw!important;
      margin:0;
  } 
  ::placeholder { 
  color: #dd052b;
  opacity: 1; 
}
  }
  .p-inputtext:enabled:hover {
    border-color: #dd052b !important;
  }
`;

const Datepicker: React.FC<DatepickerProps> = ({
  locale,
  mode,
  placeholder,
  value,
  minDate,
  maxDate,
  checkbox,
  labelButton,
  onSelectDate,
  onSearchDate,
}) => (
  <PickerContainer>
    <MyCalendar
      locale={locale}
      selectionMode={mode}
      dateFormat="dd/mm/yy"
      placeholder={placeholder}
      value={value}
      minDate={minDate}
      maxDate={maxDate}
      onChange={(e: any) => onSelectDate(e.value)}
    />
    {checkbox ? <CheckContainer> {checkbox}</CheckContainer> : <div style={{ paddingBottom: '1rem' }}></div>}
    <PrimaryButton text={labelButton} onClick={onSearchDate} />
  </PickerContainer>
);

export default Datepicker;
